import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TabsContainer, TabItem, Border, TabsWrapper } from './style';
import Icon from '../Icon';
import theme from '../../theme';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';
import Text from '../Text';

const Tabs = ({
  mediaIsPhone,
  tabs,
  onChange,
  tabType = 'primary',
  selected,
  color,
  showNumbers,
  fullWidth,
  mb = 42,
}) => {
  const [selectedTab, setSelectedTab] = useState(selected);

  useEffect(() => {
    setSelectedTab(selected);
  }, [selected]);

  const handleOnclickTab = (tab) => {
    setSelectedTab(tab);
    if (onChange) onChange(tab);
  };
  if (tabs?.length < 2) return null;

  return (
    <TabsWrapper>
      <TabsContainer
        className={tabType}
        color={color}
        items={tabs?.length || 1}
        mb={mb}
      >
        {(tabs || []).map((tab, index) => (
          <TabItem
            tabsNumber={fullWidth && tabs?.length}
            onClick={() => {
              if (tab?.disabled && !tab?.completed) return;
              handleOnclickTab(tab);
            }}
            key={tab.value}
            className={`${tabType} ${
              tab.label === selectedTab?.label ? 'active' : ''
            } ${tab?.class ?? ''}`}
            color={color}
            disabled={tab?.disabled && !tab?.completed}
          >
            {tab?.icon && mediaIsPhone && <Icon type={tab.icon} size={20} />}
            <span>
              {showNumbers && `0${index + 1}. `}
              {tab.label}
              {tab?.items !== undefined && ` (${tab?.items})`}
              {tab?.icon && !mediaIsPhone && <Icon type={tab.icon} size={20} />}
            </span>
            {tab?.completed && (
              <Icon type="check-circle" stroke={theme().colors.successIcon} />
            )}
            {tab.label === selectedTab?.label && (
              <div className="active-border" />
            )}
            {tab?.completed && tab.label !== selectedTab?.label && (
              <Text type="b5" className="edit">
                {tab?.subLabel} <Icon type={tab?.subIcon} size={18} />
              </Text>
            )}
          </TabItem>
        ))}
      </TabsContainer>
      <Border className={tabType} />
    </TabsWrapper>
  );
};

Tabs.propTypes = {
  mediaIsPhone: PropTypes.bool,
  showNumbers: PropTypes.bool,
  tabs: PropTypes.array.isRequired,
  tabType: PropTypes.string,
  selected: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string,
  fullWidth: PropTypes.bool,
  mb: PropTypes.number,
};

export default withMediaQueries(Tabs);
